import { PaywallAccessType } from '@paywall/types';
import { Config } from '@root/modules/channel/types/channel';

type GetAccessVariables = {
  accessToken: string | null;
  accessType: PaywallAccessType;
};
interface Arguments {
  application?: Config['settings']['application'];
  zlickToken: string | null;
  customerToken: string | null;
}

function getAccessVariables({ application, zlickToken, customerToken }: Arguments): GetAccessVariables {
  const isElisaRaamat = application?.type === 'ElisaRaamat';

  let accessToken: string | null = zlickToken || customerToken || null;
  let accessType = zlickToken ? 'Zlick' : 'Customer';

  if (application && isElisaRaamat) {
    accessToken = application.signature;
    accessType = application.type as string;
  }

  return {
    accessToken,
    accessType,
  } as GetAccessVariables;
}

export default getAccessVariables;
